import Chip from '@mui/material/Chip';

export const TRIP_FILTERS = [
  'Completed',
  'Transport Accepted',
  'Canceled'
];

// Utility to get the status badge
export const getStatusBadge = (status) => {
  let color;
  let label;
 console.log(status)
  switch (status) {
    case 'Completed':
      color = 'success'; 
      label = 'Completed';
      break;
    case 'Transport Accepted':
      color = 'primary'; 
      label = 'Transport Accepted';
      break;
    case 'Canceled':
      color = 'error'; 
      label = 'Canceled';
      break;
    default:
      color = 'default'; 
      label = 'Unknown';
      break;
  }

  return <Chip label={label} color={color} />;
};
